import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useNotify } from 'react-admin';

import { useMarkNotificationDownloaded } from './useMarkNotificationDownloaded';

type Props = {
  notificationId: string;
  fileUrl: string;
  onSuccess?: () => void;
};

export function useDownloadReport({ notificationId, fileUrl, onSuccess }: Props): VoidFunction {
  const translate = useTypedTranslate();
  const notify = useNotify();
  const { markNotificationDownloaded } = useMarkNotificationDownloaded({ onSuccess });

  const downloadReport = () => {
    if (!fileUrl) {
      return;
    }
    const opened = window.open(fileUrl, '_blank');
    if (!opened) {
      notify(translate('app.common.fileDownloadFailure'), { type: 'error' });
      return;
    }

    markNotificationDownloaded(notificationId);
  };

  return downloadReport;
}
